<!-- Итоговая строка грузов заказа: суммирует места, вес и объем. -->
<template>
  <BaseMetricsBlocks aria-label="Сводка грузов" :metrics="metrics" />
</template>

<script>
import {
  cargoNumber,
  roundCargoVolume,
  volumeM3FromMeterDimensions,
} from "@/utils/cargoCalculatorUtils";

export default {
  name: "OrderCargoSummary",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    itemsCount() {
      return this.items.length;
    },

    metrics() {
      return [
        {
          key: "items",
          icon: "cargo",
          label: "Грузов",
          value: this.itemsCount,
          detail: "позиций в заказе",
        },
        {
          key: "weight",
          icon: "weight",
          label: "Общий вес",
          value: `${this.totalWeight} кг`,
          detail: "масса брутто",
        },
        {
          key: "volume",
          icon: "volume",
          label: "Общий объём",
          value: `${this.totalVolume} м³`,
          detail: "по объёму или габаритам",
        },
      ];
    },

    totalWeight() {
      const total = this.items.reduce((sum, item) => {
        const grossWeight = cargoNumber(item.gross_weight_kg) || 0;
        return sum + grossWeight;
      }, 0);

      return this.formatTotal(total);
    },

    totalVolume() {
      const total = this.items.reduce((sum, item) => {
        const quantity = cargoNumber(item.quantity) || 0;
        const volume = this.itemVolumeM3(item);
        return sum + quantity * volume;
      }, 0);

      return this.formatTotal(roundCargoVolume(total));
    },
  },

  methods: {
    itemVolumeM3(item) {
      return (
        cargoNumber(item.volume_m3) ||
        volumeM3FromMeterDimensions({
          heightM: item.height_m,
          lengthM: item.length_m,
          widthM: item.width_m,
        }) ||
        0
      );
    },

    formatTotal(value) {
      const number = Number(value);
      if (!Number.isFinite(number) || number <= 0) return "0";

      return Number(number.toFixed(3)).toString();
    },
  },
};
</script>
